module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginForm modal fade",
    attrs: {
      "id": "dashboardModal"
    }
  }, [_c('row', {
    staticClass: "modal-dialog",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "role": "document"
    }
  }, [_c('column', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('column', {
    staticClass: "col-md-6",
    staticStyle: {
      "width": "750px"
    }
  }, [_c('va-box', {
    attrs: {
      "name": "boxInstaller",
      "title": _vm.title,
      "theme": "box-info",
      "isBorder": true,
      "widgetType": ""
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('form', {
    staticClass: "form-horizontal",
    staticStyle: {
      "background-color": "white",
      "padding-left": "10px"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('H3', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v(" Download Printer Counters Client Installer")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_c('p', [_vm._v("To start monitoring USB and/or Network printers")]), _vm._v(" "), _c('p', [_vm._v("To Collect printers counters automatically & schedule reports")]), _vm._v(" "), _c('p', [_vm._v("Click to download :")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('downloadBtn', {
    staticStyle: {
      "width": "300px",
      "text-align": "center"
    },
    attrs: {
      "title": _vm.btnLAN.title,
      "img": _vm.btnLAN.img,
      "info": _vm.btnLAN.info,
      "icon": _vm.btnLAN.icon,
      "btnText": _vm.btnLAN.btnText
    },
    on: {
      "click": function($event) {
        return _vm.downloadLAN()
      }
    }
  }), _vm._v(" "), _c('downloadBtn', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "title": _vm.btnUSB.title,
      "img": _vm.btnUSB.img,
      "info": _vm.btnUSB.info,
      "icon": _vm.btnUSB.icon,
      "btnText": _vm.btnUSB.btnText
    },
    on: {
      "click": function($event) {
        return _vm.downloadUSB()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding": "20px",
      "text-align": "right"
    }
  }, [_c('input', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "type": "button",
      "value": "I will download later"
    },
    on: {
      "click": function($event) {
        return _vm.downloadLater()
      }
    }
  })])])])])])], 1), _vm._v(" "), _c('column', {
    staticClass: "col-md-3"
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77b5dd65!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadInstaller.vue
// module id = 729
// module chunks = 0